import { UseCaseRecursoAsync } from "src/views/core/types/UseCaseRecursoAsync";
import { DataLlave, EstadisticasLlave, EstadoLlaveAnual, ResumenByClienteProductoUsuario } from "../entities/EstadisticasLlave.entity";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { EstadisticasDsKeyRepository } from "../repositories/EstadisticasDsKeyRepository";
import { Recurso } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';

export class GetEstadisticasLlavesUseCase<
    T_OUT extends EstadisticasLlave,
    T_OUT2 extends DataLlave,
    T_OUT3 extends EstadoLlaveAnual,
    T_OUT4 extends ResumenByClienteProductoUsuario
> extends UseCaseRecursoAsync<
    FechaParams,
    T_OUT
> {
    private repository: EstadisticasDsKeyRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>;
    constructor(repository: EstadisticasDsKeyRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>) {
        super();
        this.repository = repository;
    }

    async call(input: FechaParams): Promise<Recurso<T_OUT>> {
        try {
            return this.repository.getEstadisticasLlaves(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT>(errorCapa);
        }
    }
}